export default __webpack_public_path__ + "static/media/custo.61fe9397.png";